import { useState, useEffect } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import { toast } from "react-toastify";
import { editEnquiryApi } from "../../../api/apiUrlConst";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  enquiry: any;
  onSuccess: () => void;
}

const EditEnquiryModal: React.FC<Props> = ({
  isOpen,
  toggle,
  enquiry,
  onSuccess
}) => {
  const [form, setForm] = useState({
    name: "",
    courseCategory: "",
    courseName: "",
    message: ""
  });

  useEffect(() => {
    if (enquiry) {
      setForm({
        name: enquiry.name || "",
        courseCategory: enquiry.courseCategory || "",
        courseName: enquiry.courseName || "",
        message: enquiry.message || ""
      });
    }
  }, [enquiry]);

  const handleChange = (e: any) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    try {
      await editEnquiryApi(enquiry.id, form);
      toast.success("Enquiry updated successfully");
      toggle();
      onSuccess();
    } catch (error: any) {
      toast.error(
        error.response?.data?.message ||
        error.response?.data ||
        "Update failed"
      );
    }
  };

  const courseOptions: { [key: string]: string[] } = {
    "AI ML": [
      "Artificial Intelligence",
      "Data Science",
      "Machine Learning",
    ],
    "Programming": [

      "Python Programming",
      "C++",
      "C#.Net",
      "Java",
    ],
    "CAD Automation": [
      "C++ & Creo Toolkit",
      "C++ & CATIA CAA",
      "",
      "C#.Net & Solidworks API",
      "C#.Net & Nx Customization",
      "C#.Net & Autodesk Inventor API",
      "C#.Net & AutoCAD API",
      "C#.Net & Solid Edge API",
      "C#.Net & Revit API",
      "",
      "Python & CATIA CAA",
      "Python & Nx Customization",
      "",
      "NX Customization",
      "SolidWorks API",
      "CATIA CAA",
      "Creo Toolkit",
      "Revit API",
      "AutoCAD API",
      "Solid Edge API",
      "Autodesk Inventor API",
    ],
    "PLM Automation": [
      "Java & Windchill",
      "C++ & Team center",
      "Windchill",
      "Teamcenter",
    ],
  };

  return (
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
      contentClassName="border-0 shadow-lg"
    >
      <ModalHeader
        toggle={toggle}
        style={{
          background: "linear-gradient(90deg, #667eea, #764ba2)",
          color: "#fff",
          fontWeight: 600,
        }}
      >
        Edit Enquiry
      </ModalHeader>

      <ModalBody style={{ background: "#f9fafc" }}>
        <Form className="d-flex flex-column gap-3">

          {/* Name */}
          <FormGroup>
            <Label className="fw-semibold">Name</Label>
            <Input
              name="name"
              value={form.name}
              onChange={handleChange}
              className="rounded-pill shadow-sm"
            />
          </FormGroup>

          {/* Course Category Dropdown */}
          <FormGroup>
            <Label className="fw-semibold">Course Category</Label>
            <Input
              type="select"
              name="courseCategory"
              value={form.courseCategory}   // 👈 IMPORTANT
              onChange={(e) => {
                const value = e.target.value;
                setForm((prev) => ({
                  ...prev,
                  courseCategory: value,
                  courseName: "", // reset when changed
                }));
              }}
              className="rounded-pill shadow-sm"
            >
              <option value="">Select Category</option>

              {Object.keys(courseOptions).map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </Input>
          </FormGroup>

          {/* Course Name Dependent Dropdown */}
          <FormGroup>
            <Label className="fw-semibold">Course Name</Label>
            <Input
              type="select"
              name="courseName"
              value={form.courseName}   // 👈 IMPORTANT
              onChange={handleChange}
              disabled={!form.courseCategory}
              className="rounded-pill shadow-sm"
            >
              <option value="">
                {form.courseCategory
                  ? "Select Course"
                  : "Select Category First"}
              </option>

              {form.courseCategory &&
                courseOptions[form.courseCategory]?.map(
                  (course, index) => (
                    <option key={index} value={course}>
                      {course}
                    </option>
                  )
                )}
            </Input>
          </FormGroup>

          {/* Message */}
          <FormGroup>
            <Label className="fw-semibold">Message</Label>
            <Input
              type="textarea"
              name="message"
              rows={3}
              value={form.message}
              onChange={handleChange}
              className="rounded-3 shadow-sm"
            />
          </FormGroup>

        </Form>
      </ModalBody>

      <ModalFooter
        style={{
          background: "#f9fafc",
          borderTop: "none",
        }}
      >
        <Button
          color="secondary"
          outline
          onClick={toggle}
          className="rounded-pill px-4"
        >
          Cancel
        </Button>

        <Button
          onClick={handleSubmit}
          style={{
            background: "linear-gradient(90deg, #667eea, #764ba2)",
            border: "none",
          }}
          className="rounded-pill px-4"
        >
          Update
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditEnquiryModal;